/* eslint-disable react/jsx-pascal-case */
/* eslint-disable eqeqeq */

import DropdownButton from "react-bootstrap/DropdownButton";

import Dropdown from "react-bootstrap/Dropdown";
import React, { useCallback, useEffect, useState, useRef } from "react";
import "./BinTransferMain.css";
import { useNavigate } from "react-router-dom";
import BinTransfer_Breadcrumbs from "./BinTransfer_BreadCrumbs";
import { useSelector, useDispatch } from "react-redux";
import { fExecuteAPI } from "../../Server/Apis";
//Audit
import GCAudit from "../../Component/Common/ReuseableComponent/GCAudit";
import {
  CmpSelectBox,
  CmpTextField,
  CmpDatePicker,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { BintransferHead_Set } from "./SliceBinTransfer";
import "react-toastify/dist/ReactToastify.css";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment/moment";
import GCWebReport from "./../../Component/Common/ReuseableComponent/GCWebReport";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";

export default function BinTrnasferForm() {
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [Audit_GridData_Columns, setAudit_GridData_Columns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },

    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const BintrasferFormFocusOnLoad = useRef(null);
  const vRdxBinTransferForm = useSelector(
    (state) => state.SliceBinTransfer.value.BintransferHead
  );

  const [typeData, settypeData] = useState([
    { UId: "Between Bin", Name1: "Between Bin" },
    { UId: "To Open", Name1: "To Open" },
    { UId: "From Open", Name1: "From Open" },
  ]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [locData, setLocData] = useState(vRdxuserLoc);
  const [docData, setDocData] = useState([]);
  const [resData, setResData] = useState([]);

  const [sDisableSelect, SetDisableSelect] = useState(0);

  // const [sFormValidation, setFormValidation] = useState(false);

  const [sErrorMsg, setErrorMsg] = useState({
    DocType: "",
    DocTypName: "",
    DocNo: "",
    Date: "",
    LocCode: "",
    Reason: "",
    Narration: "",
    Type: "",
    Status: "",
    UserCd: "",
    IP: "",
  });
  const [sHeaderData, setHeaderData] = useState(vRdxBinTransferForm);

  const vDocLoadingObj = {
    GroupId: vRdxuserInfo.UserGroupCode,
    Nature: "IN",
    TrnCode: "TB",
    UserId: vRdxuserInfo.UserID,
  };

  const GetDocLoading = async () => {
    const vDocLoading = await fExecuteAPI(
      "GET_API_DOC_LOADING",
      vDocLoadingObj
    );

    if (vDocLoading.Type?.toUpperCase() === "SUCCESS") {
      if (vDocLoading?.ResultSet?.length > 0) {
        setDocData(vDocLoading?.ResultSet);
        if (
          sHeaderData.DocType == "" ||
          sHeaderData.DocType == null ||
          sHeaderData.DocType == undefined
        ) {
          setHeaderData((obj) => ({
            ...obj,
            DocType: vDocLoading.ResultSet[0].VocTyp,
            DocTypName: vDocLoading.ResultSet[0].VocName,
          }));
        }
      } else {
        setDocData([]);
      }
    } else {
      fAlertToast("FAILED", vDocLoading.Message);
    }
  };

  const GetReasonData = async () => {
    const vReasonLoading = await fExecuteAPI("BIN_TRANSFER_REASON");
    if (vReasonLoading?.Type?.toUpperCase() === "SUCCESS") {
      if (vReasonLoading?.ResultSet?.length > 0) {
        setResData(vReasonLoading.ResultSet);
        if (
          sHeaderData.Reason == "" ||
          sHeaderData.Reason == null ||
          sHeaderData.Reason == undefined
        ) {
          setHeaderData((obj) => ({
            ...obj,
            Reason: vReasonLoading.ResultSet[0].UId,
          }));
        }
      } else {
        setResData([]);
      }
    } else {
      fAlertToast("FAILED", vReasonLoading.Message);
    }
  };

  const GetBinTransDetailCount = async () => {
    let vBinTransDetailCountObj = {
      v_DocTyp: sHeaderData.DocType,
      v_DocNo: sHeaderData.DocNo,
    };
    const vBinTransDetailCount = await fExecuteAPI(
      "GET_API_BIN_TRANSFER_DETAILCOUNT",
      vBinTransDetailCountObj
    );
    if (vBinTransDetailCount?.Type?.toUpperCase() === "SUCCESS") {
      if (vBinTransDetailCount.ResultSet.length > 0) {
        SetDisableSelect(vBinTransDetailCount.ResultSet[0].Cnt);
      } else {
        SetDisableSelect(0);
      }
    } else {
      fAlertToast("FAILED", vBinTransDetailCount.Message);
    }
  };

  const GetBinTransferPosting = async () => {
    let vBinTransferPostingObj = {
      v_VocTyp: sHeaderData.DocType,
      v_VocNo: sHeaderData.DocNo,
      v_UserCd: vRdxuserInfo.UserID,
    };
    const vBinTransferPosting = await fExecuteAPI(
      "GET_API_BIN_TRANSFER_POSTING",
      vBinTransferPostingObj
    );
    if (vBinTransferPosting?.Type?.toUpperCase() === "SUCCESS") {
      setHeaderData((obj) => ({ ...obj, Status: "POST" }));
      dispatch(
        BintransferHead_Set({
          BintransferHead: { ...sHeaderData, Status: "POST" },
        })
      );
      BintrasferFormFocusOnLoad?.current?.focus();
      fAlertToast("SUCCESS", "Posted Successfully");
    } else if (
      vBinTransferPosting?.Type?.toUpperCase() === "FAILED" &&
      vBinTransferPosting?.Status === 200
    ) {
      fAlertToast("WARNING", vBinTransferPosting.Message);
    } else {
      fAlertToast("FAILED", vBinTransferPosting.Message);
    }
  };

  const GetReadParameter = async () => {
    if (
      vRdxDBKernObj &&
      vRdxDBKernObj["3RD_PARTY_ERP"] &&
      vRdxDBKernObj["3RD_PARTY_ERP"].Val === "Y"
    ) {
      settypeData([{ UId: "Between Bin", Name1: "Between Bin" }]);
      setHeaderData((obj) => ({
        ...obj,
        Type: sHeaderData.Type == "" ? "Between Bin" : sHeaderData.Type,
      }));
    } else {
      let vReadParameterObj = {
        ParamKey: "WMS_OPEN_BIN_ACTIVE",
      };
      const vReadParameter = await fExecuteAPI(
        "GET_API_READ_PARAMETER",
        vReadParameterObj
      );
      if (vReadParameter?.Type?.toUpperCase() === "SUCCESS") {
        if (vReadParameter?.ResultSet[0]?.Val === "Y") {
          //TO OPEN,FROM OPEN
          // let NewTypeDataArr = typeData?.filter(obj => {
          //     return obj?.UId === "To Open" || obj?.UId === "From Open" || obj?.UId === "Between Bin"
          // });
          settypeData(typeData);
          setHeaderData((obj) => ({
            ...obj,
            Type: sHeaderData.Type == "" ? typeData[0]?.UId : sHeaderData.Type,
          }));
        } else {
          //Between Bin
          let NewTypeDataArr = typeData?.find((obj) => {
            return obj?.UId === "Between Bin";
          });
          settypeData(NewTypeDataArr);
          setHeaderData((obj) => ({
            ...obj,
            Type:
              sHeaderData.Type == ""
                ? NewTypeDataArr[0]?.UId
                : sHeaderData.Type,
          }));
        }
        //  else if (sDisableSelect == 0) {
        //   let NewTypeDataArr = typeData?.find((obj) => {
        //     return obj?.UId === sHeaderData.Type;
        //   });

        // }
      } else if (vReadParameter?.Type?.toUpperCase() === "FAILED") {
        fAlertToast("FAILED", vReadParameter.Message);
      }
    }
  };

  //transfer on click
  const fUpdateHeadInfo = useCallback(
    async (e) => {
      if (sHeaderData.Status.toUpperCase() == "ENTER") {
        if (setValidation()) {
          const iAPIResult = await fExecuteAPI("BIN_TRANSFER_HeadUPDATE", {
            ...sHeaderData,
            Date: moment(sHeaderData.Date).format("MM/DD/YYYY"),
          });
          if (iAPIResult.Type?.toUpperCase() == "SUCCESS") {
            if (iAPIResult.ResultSet.length > 0) {
              setHeaderData((obj) => ({
                ...obj,
                DocNo: iAPIResult.ResultSet[0].VocNo,
              }));
              dispatch(
                BintransferHead_Set({
                  BintransferHead: {
                    ...sHeaderData,
                    DocNo: iAPIResult.ResultSet[0].VocNo,
                  },
                })
              );
              navigate(e == "OUT" ? "/BinTransfer/Out" : "/BinTransfer/In");
            }
          } else {
            fAlertToast("FAILED", iAPIResult.Message);
          }
        }
      } else {
        navigate(e == "OUT" ? "/BinTransfer/Out" : "/BinTransfer/In");
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sHeaderData]
  );

  const fPost = () => {
    GetBinTransferPosting();
  };

  const fOnChangeValues = useCallback(
    (e) => {
      setHeaderData((obj) => ({
        ...obj,
        [e.target.name]: e.target.value,
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sHeaderData]
  );

  const setValidation = () => {
    setErrorMsg({
      DocType: "",
      DocTypName: "",
      DocNo: "",
      Date: "",
      LocCode: "",
      Reason: "",
      Narration: "",
      Type: "",
      Status: "",
      UserCd: "",
      IP: "",
    });
    let iRes = true;
    if (sHeaderData.DocType === "") {
      setErrorMsg((obj) => ({ ...obj, DocType: "DocType is Empty" }));
      iRes = false;
    }
    if (sHeaderData.DocTypName === "") {
      setErrorMsg((obj) => ({ ...obj, DocTypName: "DocTypName is Empty" }));
      iRes = false;
    }
    if (sHeaderData.DocNo === "") {
      setErrorMsg((obj) => ({ ...obj, DocNo: "DocNo is Empty" }));
      iRes = false;
    }
    if (sHeaderData.Date === "") {
      setErrorMsg((obj) => ({ ...obj, Date: "Date is Empty" }));
    }
    if (sHeaderData.LocCode === "") {
      setErrorMsg((obj) => ({ ...obj, LocCode: "LocCode is Empty" }));
      iRes = false;
    }
    if (sHeaderData.DocType === "") {
      setErrorMsg((obj) => ({ ...obj, DocType: "DocType is Empty" }));
      iRes = false;
    }
    if (sHeaderData.Reason === "") {
      setErrorMsg((obj) => ({ ...obj, Reason: "Reason is Empty" }));
      iRes = false;
    }
    if (sHeaderData.Type === "") {
      setErrorMsg((obj) => ({ ...obj, Type: "Type is Empty" }));
      iRes = false;
    }
    if (sHeaderData?.Status === "") {
      setErrorMsg((obj) => ({ ...obj, Status: "Status is Empty" }));

      iRes = false;
    }
    // if (sHeaderData.Narration === "") {
    //     setErrorMsg((obj) => ({ ...obj, Narration: "Narration is Empty", }));
    //     iRes = false;
    // }
    return iRes;
  };
  //audit

  //Modal Audit
  const sTrnTyp = "WMTSR";
  const [sAudit_Id, setAudit_Id] = useState("All");
  const [sAudit_Modal, setAudit_Modal] = useState(false);
  const [sAudit_Select_Arr, setAudit_SelectArr] = useState([]);
  const [sAudit_GridData_Rows, setAudit_GridData_Rows] = useState([]);
  const fOpenAuditModal = () => {
    setAudit_Modal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAudit_Id(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };
  const fAudit_Close_Modal = (e) => {
    setAudit_Modal(false);
  };
  const fAudit_onChange_Select = (e) => {
    setAudit_Id(e.target.value);
    GetTransAudit(e.target.value);
  };

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAudit_SelectArr(vAuditField?.ResultSet);
      return vAuditField?.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField?.Message);
      return vAuditField?.ResultSet;
    }
  };
  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: sHeaderData.DocType,
      vocNo: sHeaderData.DocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", vTransAuditObj);
    if (vTransAudit.Type?.toUpperCase() === "SUCCESS") {
      if (vTransAudit?.ResultSet?.length > 0) {
        let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setAudit_GridData_Rows(vTransAuditRes);
      }
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };
  //useEffect
  useEffect(() => {
    GetDocLoading();
    GetReasonData();
    GetReadParameter();
    document.getElementsByName("DocType")[0]?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    GetBinTransDetailCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sHeaderData.DocNo]);
  // useEffect(() => {
  //   setHeaderData((obj) => ({
  //     ...obj,
  //     DocType: vRdxBinTransferForm.DocType,
  //     DocTypName: vRdxBinTransferForm.DocTypName,
  //     DocNo: vRdxBinTransferForm.DocNo,
  //   }));
  // }, [vRdxBinTransferForm]);
  useEffect(() => {
    console.log("sHeaderData", sHeaderData);
  }, [sHeaderData]);

  useEffect(() => {
    BintrasferFormFocusOnLoad.current?.focus();
  }, []);

  useEffect(() => {
    GetGitterColumns(
      setAudit_GridData_Columns,
      "BIN_TRANSFER_AUDIT",
      Audit_GridData_Columns
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  // http://172.11.7.250:8020/
  // (S(1t4sx34qb3vdqeqqled2sglf))
  // /WMS/BinTransfer?trntyp=BNTSR_DETAIL&VocTyp=TB001&VocNo=BT00000001

  const fPrint = useCallback(
    (xPrnTyp) => {
      let PrintURl =
        vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val +
        "WMS/BinTransfer?trntyp=" +
        xPrnTyp +
        "&VocTyp=" +
        sHeaderData.DocType +
        "&VocNo=" +
        sHeaderData.DocNo;
      console.log("PrintURl", PrintURl);
      setWebReportUrlModal(PrintURl);
      fWebReport();
    },
    [vRdxDBKernObj, sHeaderData.DocNo, sHeaderData.DocType]
  );

  return (
    <>
      <div>
        <BinTransfer_Breadcrumbs />
      </div>
      <div className="BinTransferContainer">
        {/* <BinTransfer_Breadcrumbs /> */}
        <div className="BinTransferUnderContainer">
          <div className="BinTransferFormContainer">
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
                style={{
                  textAlign: "center",
                }}
                columns={{ xs: 24, sm: 12, md: 12 }}
              >
                <Grid item xs={12}>
                  <CmpSelectBox
                    xLabelText="Document type"
                    xValue={sHeaderData.DocType}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xName={"DocType"}
                    xData={docData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.DocType === "" ? false : true}
                    xErrorMessage={sErrorMsg.DocType}
                    xDisable={sDisableSelect == 0 ? false : true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpDatePicker
                    xLabelText={"Date"}
                    xValue={sHeaderData.Date}
                    xOnChange={(newValue) =>
                      setHeaderData((obj) => ({
                        ...obj,
                        VocDt: newValue.$d,
                      }))
                    }
                    xName={"Date"}
                    xError={sErrorMsg.Date === "" ? false : true}
                    xErrorMessage={sErrorMsg.Date}
                    xFullWidth={true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpTextField
                    xref={BintrasferFormFocusOnLoad}
                    xLabelText={"Document No"}
                    xVariant={"outlined"}
                    xValue={sHeaderData.DocNo}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"DocNo"}
                    xError={sErrorMsg.DocNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.DocNo}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpSelectBox
                    xLabelText="Location"
                    xValue={sHeaderData.LocCode}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xName={"LocCode"}
                    xData={locData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.LocCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.LocCode}
                    xDisable={sDisableSelect == 0 ? false : true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpSelectBox
                    xLabelText="Reason"
                    xValue={sHeaderData.Reason}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xName={"Reason"}
                    xData={resData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.Reason === "" ? false : true}
                    xErrorMessage={sErrorMsg.Reason}
                    xDisable={false}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CmpTextField
                    xLabelText={"Narration"}
                    xVariant={"outlined"}
                    xValue={sHeaderData.Narration}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"Narration"}
                    xError={sErrorMsg.Narration === "" ? false : true}
                    xErrorMessage={sErrorMsg.Narration}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpSelectBox
                    xLabelText="Type"
                    xValue={sHeaderData.Type}
                    xOnChange={(event) => fOnChangeValues(event)}
                    xName={"Type"}
                    xData={typeData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.Type === "" ? false : true}
                    xErrorMessage={sErrorMsg.Type}
                    xDisable={sDisableSelect == 0 ? false : true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CmpTextField
                    xLabelText={"Status"}
                    xVariant={"outlined"}
                    xValue={sHeaderData.Status}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Status"}
                    xError={sErrorMsg?.Status === "" ? false : true}
                    xErrorMessage={sErrorMsg?.Status}
                  />
                </Grid>
              </Grid>
            </Box>
          </div>

          <div
            className="BinTransferFooterBtnContainer"
            style={{ marginTop: "3rem", textAlign: "center" }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                columns={{ xs: 6, sm: 6, md: 12, lg: 12 }}
                justifyContent={"center"}
              >
                <Grid item xs={2.4}>
                  <CmpButton
                    xbtnName="Post"
                    xOnClick={fPost}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={2.4} className="xs-screen-hide">
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="primary"
                    size="md"
                    disabled={false}
                  >
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("BNTSR_DETAIL");
                      }}
                    >
                      Details
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        fPrint("BININVSOUT");
                      }}
                    >
                      BIN IN VS OUT
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={2.4}>
                  <CmpButton
                    xbtnName="Trans Out"
                    xOnClick={() => {
                      fUpdateHeadInfo("OUT");
                    }}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={2.4}>
                  <CmpButton
                    xbtnName="Trans In"
                    xOnClick={() => {
                      fUpdateHeadInfo("IN");
                    }}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
                <Grid item xs={2.4}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={fAudit}
                    xVariant="contained"
                    xDisabled={false}
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </div>
        </div>
      </div>
      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAudit_Modal}
        xTitle={"AUDIT"}
        fCloseAuditModal={fAudit_Close_Modal}
        sAuditSelectArr={sAudit_Select_Arr}
        GridDataAuditColumns={Audit_GridData_Columns}
        GridDataAuditRows={sAudit_GridData_Rows}
        xAuditId={sAudit_Id}
        fonChangeAuditSelect={fAudit_onChange_Select}
        xLabel={sHeaderData.DocTypName + " - " + sHeaderData.DocNo}
      /> */}

      <GCAuditTblCard
        xOpen={sAudit_Modal}
        xLabel={sHeaderData.DocTypName + " - " + sHeaderData.DocNo}
        fCloseAuditModal={fAudit_Close_Modal}
        trnTyp={sTrnTyp}
        vocTyp={sHeaderData.DocType}
        vocNo={sHeaderData.DocNo}
      />

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </>
  );
}
